<footer class="statusbar">
  <div class="group">
    <span class="status-chip">
      <span class="dot pulse"></span>Connected to FINRA API
    </span>
    <span class="status-chip">
      <span class="dot pulse"></span>SEC EDGAR Sync Active
    </span>
  </div>
  <div class="group">
    <span>{{ version }}</span>
    <span class="status-chip">
      <dmp-icon name="help" size="sm" />
      Help
    </span>
  </div>
</footer>
